import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { mediaQuery } from "@zendeskgarden/react-theming"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Media } from "../../lib/media-queries"
import { H1, Subheading } from "../../styles/typography"
import { gatsbyImageDataShape } from "../../lib/prop-types"

const Banner = styled.div`
  display: grid;
  grid-template: ${({ theme }) =>
    `${theme.space.xl} ${theme.space.xl} 1fr ${theme.space.xl} / ${theme.space.xl} 1.5fr ${theme.space.xl} 1fr ${theme.space.xl}`};

  ${props => mediaQuery("down", "lg", props.theme)} {
    grid-template: ${({ theme }) =>
      `${theme.space.xl} 1fr ${theme.space.xl} / ${theme.space.xl} 2fr ${theme.space.xl} 1fr ${theme.space.xl}`};
  }

  ${props => mediaQuery("down", "xs", props.theme)} {
    grid-template-columns: ${({ theme }) =>
      `${theme.space.md} 1fr 1fr 1fr ${theme.space.md}`};
  }
`

const BannerBackground = styled.div`
  grid-area: 2 / 1 / 5 / 6;
  background-color: ${props => props.backgroundColor};

  ${props => mediaQuery("down", "lg", props.theme)} {
    grid-area: 1 / 1 / 4 / 6;
  }

  ${props => mediaQuery("down", "xs", props.theme)} {
    grid-area: 1 / 1 / 5 / 6;
  }
`

const TextBlock = styled.div`
  grid-area: 3 / 2 / 4 / 3;
  align-self: center;

  ${props => mediaQuery("down", "lg", props.theme)} {
    grid-area: 2 / 2 / 3 / 3;
  }

  ${props => mediaQuery("down", "xs", props.theme)} {
    grid-area: 2 / 2 / 3 / 5;
  }
`

const StyledSubheading = styled(Subheading)`
  margin-bottom: 0;
  color: ${props => props.color};
`

const StyledMedia = styled(Media)`
  grid-area: 1 / 4 / 4 / 5;
  align-self: end;
  justify-self: end;

  ${props => mediaQuery("down", "lg", props.theme)} {
    grid-area: 2 / 4 / 3 / 5;
  }
`

const HeroBanner = ({
  className,
  heading,
  subheading,
  imageData,
  imageAltText,
  backgroundColor,
  subheadingColor
}) => (
  <Banner className={className}>
    <BannerBackground
      data-testid="dev-docs-hero-banner-background"
      backgroundColor={backgroundColor}
    />
    <TextBlock>
      <H1 bigger>{heading}</H1>
      <StyledSubheading color={subheadingColor}>{subheading}</StyledSubheading>
    </TextBlock>
    <StyledMedia greaterThan="xs">
      <GatsbyImage
        image={getImage(imageData)}
        alt={imageAltText}
        imgStyle={{ objectFit: "contain" }}
      />
    </StyledMedia>
  </Banner>
)

HeroBanner.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
  imageData: gatsbyImageDataShape.isRequired,
  imageAltText: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  subheadingColor: PropTypes.string
}

HeroBanner.defaultProps = {
  className: null,
  backgroundColor: null,
  subheadingColor: null
}

export default HeroBanner
